module.exports = __webpack_public_path__ + "dash_20_app_assets/img/showcase.5da5e9c1.png";